@if (showSurvey) {
  <app-popup-container
    [title]="'GENERAL.SURVEY-TITLE' | translate"
    [icon]='"<i class=\"fal fa-clipboard\"></i>"'
    (closeClicked)="closeSurvey($event)">
    @if (!surveySelected) {
      <app-start-survey-overlay
        (openSurvey)="startSurvey($event)">
      </app-start-survey-overlay>
    }
    @if (surveySelected) {
      <iframe
        class="survey-selected"
        [src]="surveyLink| safe">
      </iframe>
    }
  </app-popup-container>
}
